import React from "react";
import CrudManager from "../components/CrudManager";
import { api, resolveMediaUrl } from "../../lib/api";

const fields = [
  { name: "title", label: "Title", required: true, fullWidth: true },
  { name: "description", label: "Description", type: "textarea", fullWidth: true },
  { name: "type", label: "Type", type: "select", options: ["News", "Notice", "Event", "Announcement"], defaultValue: "News", required: true },
  { name: "date", label: "Date", type: "date" },
  { name: "image.url", label: "Image", type: "image", fullWidth: true },
  { name: "image.alt", label: "Image Alt Text" },
  { name: "link", label: "External Link" },
  { name: "position", label: "Display Position", type: "number", defaultValue: 0, min: 0 },
  { name: "isActive", label: "News Status", type: "checkbox", defaultValue: true, help: "Show on website" },
];

export default function News() {
  return <CrudManager title="News" singular="News Item" fields={fields} apiResource={api.news} columns={[
    { label: "Image", render: (item) => item.image?.url ? <img className="admin-table-image" src={resolveMediaUrl(item.image.url)} alt={item.image.alt || item.title} /> : "—" },
    { label: "Title", accessor: "title" },
    { label: "Type", accessor: "type" },
    { label: "Date", render: (item) => item.date ? new Date(item.date).toLocaleDateString() : "—" },
    { label: "Status", render: (item) => <span className={`admin-badge ${item.isActive ? "success" : "muted"}`}>{item.isActive ? "Active" : "Hidden"}</span> },
  ]} />;
}
